import clsx from 'clsx';
import type { ForeignAmount } from '../types/models';
import { formatMoney } from '../utils/format';

/**
 * Revenue in its own currency ($ / € / £ …) in small text under an INR figure.
 * From the daily entries, so after month-end actuals it is the estimate.
 */
export function ForeignAmounts({
  items,
  className,
}: {
  items: ForeignAmount[] | undefined;
  className?: string;
}) {
  if (!items?.length) return null;
  return (
    <div
      className={clsx('num text-[11px] leading-tight font-normal text-slate-400', className)}
      title="Revenue in its own currency (from the daily entries)"
    >
      {items.map((i) => formatMoney(i.amount, i.currencyCode)).join(' · ')}
    </div>
  );
}
